import React from 'react';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';
import PaymentBuilder from '../../PaymentBuilder/PaymentBuilder';
import CartTotal from '../../Cart/CartTotal';
import Errors from '../../Errors/Errors';
import Switch from '../../Switch/Switch';

export default class OrderBuilderPayment extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
    }
  }

  render() {
    if (this.props.active_tab !== "payment") {
      return null;
    }

    return (
      <div className="tab-pane active">
        <Errors errors={this.props.errors} />
        <div className="payment">
          <div className="row">
            <div className="col-sm-6">
              <PaymentBuilder ref={this.props.paymentBuilderRef} {...this.props} card={true} showNotesTab={false} ignoreFolios={true} ignoreModalButtons={true} customerOptional={true} order={this.props.order} onPaymentLogSave={this.props.onPaymentLogSave} payment_log={{payment_log_folios: [{amount: this.props.order?.total_amount, folio_id: this.props.order?.folio_id}]}} hideCardSource={true}/>
            </div>
            <div className="col-sm-6">
              <CartTotal {...this.props} allowEdit={false} loading={this.props.calculating_pricing} />
              <div style={{marginTop: '15px'}}>
                <label style={{marginBottom: '0px'}}>{I18n.t('mark_order_as_completed')}</label>
                <Switch 
                  onText="yes" 
                  offText="no" 
                  onChange={this.props.onChangeMarkOrderAsCompleted} 
                  value={this.props.order?.status === "completed"} 
                  switchId="mark_order_as_completed_switch"
                />
              </div>
            </div>
          </div>
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    )
  }

};
